import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";
import {CompetitorsRequestParams} from "../../../../domain/competitors/models/competitors.request-params";
import {CompetitorsDomainService} from "../../../../domain/competitors/services/competitors.domain-service";
import type {NewSearchWidgetController} from "../../new-search-widget.controller";
import type {NewSearchWidgetState} from "../../models/new-search-widget.state";
import {FetchHandler} from "../../../../infrastructure/handlers/fetch-handler";
import {CompetitorViewModel} from "../../../../domain/common/competitor/models/competitor-view-model";
import {NewSearchWidgetListModel} from "../../models/new-search-widget.list.model";
import {COMPONENT_STATES} from "../../../../core/consts";

export class NewSearchWidgetTopCompetitorsFetchHandler extends FetchHandler {
  state: NewSearchWidgetState;
  controller: NewSearchWidgetController;
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.TOP_ENTITIES.fetchCompetitors;

  static injectables = [CompetitorsDomainService];

  onLoaded() {
    super.onLoaded();

    this.action();
  }

  get requestParams(): CompetitorsDomainService {
    const limit: Number = this.controller.device.isSmallView ? NEW_SEARCH_WIDGET.MAX_TOP_ENTITIES.mobile : NEW_SEARCH_WIDGET.MAX_TOP_ENTITIES.desktop;
    const requestParams: CompetitorsRequestParams = new CompetitorsRequestParams(null, null, true, limit);

    return requestParams;
  }

  async action() {
    const dataSource = await super.fetch();

    if(dataSource?.competitors?.length > 0) {
      const entities = dataSource.competitors?.map(competitor => new CompetitorViewModel(competitor))
      this.state.updateCompetitorsListModel(new NewSearchWidgetListModel(NEW_SEARCH_WIDGET.LIST_ID.topCompetitors, entities, 'WEB_SEARCH_POPULAR_TEAMS', this.controller.terms, this.controller.device.isSmallView, false, NEW_SEARCH_WIDGET.HIGHLIGHTED_LIST_INDEX.competitors));
    }
    this.store.setComponentState(COMPONENT_STATES.loaded);

  }
}
